// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-padding {
  padding: 0 !important;
}

.left-col {
  padding-left: 0 !important;
  padding-right: 5px !important;
}

.right-col {
  padding-right: 0 !important;
  padding-left: 5px !important;
}

.info-text-medium {
  font-size: var(--font-size-medium) !important;
}

.info-text-small {
  font-size: var(--font-size-small) !important;
}

/* ===================== FAB BUTTONS ===================== */
/* Keep your structure, but reduce repetition and ensure predictable sizing */
.avatar-fab,
.fab {
  margin: 5px 0;
}
.avatar-fab ion-fab-button,
.fab ion-fab-button {
  width: 100%;
  height: 100%;
}
.avatar-fab ion-icon,
.fab ion-icon {
  width: 50%;
  height: 50%;
}

.text-warning {
  color: var(--ion-color-warning);
}

.text-danger {
  color: var(--ion-color-danger);
}

/* ===================== MAIN CARD ===================== */
.pilot-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  border-radius: 5px;
  overflow: hidden;
}

.pilot-info-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 5px;
  min-height: 0;
}

/* ===================== HEADER ROW ===================== */
/* Row can keep its structure, but allow it to grow naturally */
.pilot-info-row {
  width: 100%;
  height: 20%;
  min-height: 0;
  max-height: 160px;
  align-items: center;
}

/* Ion-avatar host: do NOT use 100%/100% here on big screens */
.pilot-avatar {
  /* stable responsive size */
  width: clamp(64px, 8vw, 120px);
  height: clamp(64px, 8vw, 120px);
  display: flex;
  justify-content: center;
  align-items: center;
  /* ionic default sometimes clips inner content */
  overflow: visible !important;
}

/* Real DOM wrapper: anchors the FAB reliably */
.avatar-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
}

/* mask clips to circle AND centers content */
.avatar-mask {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white; /* keep if you want */
}

/* IMPORTANT: don't stretch logos to 100% both ways */
.avatar-mask img.avatar-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
}

/* Image/icon fill wrapper */
.avatar-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain; /* show full image */
  object-position: center; /* center it */
  background: white; /* optional: prevents transparent logos looking odd */
}

/* FAB stays inside the avatar even on huge screens */
.avatar-fab {
  position: absolute;
  bottom: 2px;
  left: 4px;
  z-index: 20;
  /* keep clickable and visible */
  overflow: visible !important;
}

/* ion-icon placeholder should also behave like the image */
.pilot-avatar ion-icon.avatar-image {
  border-radius: 50%;
}

/* Pilot info column */
.pilot-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
}

.actions-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

/* ===================== ADDRESS ===================== */
.address-info-row {
  width: 100%;
  height: 7.5%;
  min-height: 0;
}

.address-info-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
}

.address-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 5px;
}

.address-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
  min-width: 0;
}

/* ===================== OTHER INFO ===================== */
.other-info-row {
  width: 100%;
  height: 7.5%;
  min-height: 0;
}

.other-info-col-left {
  padding: 0 5px 0 0;
  height: 100%;
  min-height: 0;
}

.other-info-col-right {
  padding: 0 0 0 5px;
  height: 100%;
  min-height: 0;
}

.id-info-card,
.mocca-info-card {
  height: 100%;
  display: flex;
  flex-direction: row;
  padding: 5px;
  margin: 0;
  border-radius: 5px;
}

.id-icon-col,
.mocca-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.id-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
  min-width: 0;
}

.mocca-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-width: 0;
}

/* ===================== CERTIFICATES + VEHICLES ===================== */
.certificates-row {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.certificates-col {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 0;
}

.certificates-card {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.certificates-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 12%;
  padding: 5px;
  flex: 0 0 auto;
}

.certificates-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.certificates-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
  min-width: 0;
}

/* Grid list that scrolls correctly inside flex layout */
.certificates-card-content {
  width: 100%;
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 30%));
  grid-auto-rows: min-content;
  justify-content: center;
  overflow-y: auto;
  padding: 5px;
  gap: 10px;
}

.certificate-card {
  width: 100% !important;
  margin: 0;
  height: auto;
  flex: 0 0 auto;
}

.certificate-row {
  min-height: 0;
  height: auto !important;
  display: flex;
  width: 100%;
}
.certificate-row ion-col {
  height: auto !important;
  padding: 5px !important;
}

.certificate-image {
  max-height: 25px;
  width: 100%;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.certificate-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.certificate-info-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.certificate-arrow {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.certificate-expand-icon {
  cursor: pointer;
}

.collapsible-content {
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: 0;
  display: flex;
  flex-direction: column;
}
.collapsible-content.expanded {
  max-height: 200px;
}

.always-visible {
  display: block !important;
}

/* ===================== ASSOCIATED VEHICLES ===================== */
.associated-vehicles-col {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  min-height: 0;
}

.associated-vehicles-card {
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.associated-vehicles-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 12%;
  padding: 5px;
  flex: 0 0 auto;
}

.associated-vehicles-icon-col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.associated-vehicles-info-col {
  display: flex;
  justify-content: left;
  align-items: center;
  min-width: 0;
}

.associated-vehicles-card-content {
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 5px;
  gap: 10px;
  justify-content: center;
}

.session-item-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 0;
  padding: 5px 10px;
  align-items: center;
  width: 100%;
}

.session-info-col {
  display: flex;
  flex-direction: column;
  margin-left: 1vw;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}
.session-info-col ion-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

.droneIcon {
  width: var(--icon-size-large);
  height: var(--icon-size-large);
  flex: 0 0 auto;
}

/* ===================== MEDIA QUERIES ===================== */
/*#region Small Screens*/
@media (max-width: 599px) {
  .fab {
    width: 25px;
    height: 25px;
  }
  .avatar-fab {
    width: 15px;
    height: 15px;
  }
  .card-icon {
    font-size: 20px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
@media (min-width: 600px) and (max-width: 1023px) {
  .fab {
    width: 35px;
    height: 35px;
  }
  .avatar-fab {
    width: 25px;
    height: 25px;
  }
  .card-icon {
    font-size: 25px;
  }
  .info-text {
    font-size: var(--font-size-small);
  }
  .certificate-arrow {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
@media (min-width: 1024px) {
  .fab {
    width: 45px;
    height: 45px;
  }
  .avatar-fab {
    width: 35px;
    height: 35px;
  }
  .card-icon {
    font-size: 35px;
  }
  .info-text {
    font-size: var(--font-size-medium);
  }
  .collapsible-content {
    max-height: 200px !important;
  }
  .certificate-arrow {
    display: none !important;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/fleet/components/pilot-info-card/pilot-info-card.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,2BAAA;EACA,4BAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,4CAAA;AACF;;AAEA,4DAAA;AACA,6EAAA;AACA;;EAEE,aAAA;AACF;AACE;;EACE,WAAA;EACA,YAAA;AAEJ;AACE;;EACE,UAAA;EACA,WAAA;AAEJ;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA,0DAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,aAAA;AACF;;AAEA,2DAAA;AACA,+DAAA;AACA;EACE,WAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA,8DAAA;AACA;EACE,2BAAA;EACA,8BAAA;EACA,+BAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gDAAA;EACA,4BAAA;AADF;;AAIA,+CAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAIA,6CAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,iBAAA,EAAA,qBAAA;AAHF;;AAMA,qDAAA;AACA;EACE,WAAA;EACA,YAAA;EAEA,eAAA;EACA,gBAAA;EAEA,mBAAA;EACA,uBAAA;EAEA,cAAA;AANF;;AASA,4BAAA;AACA;EACE,WAAA;EACA,YAAA;EAEA,cAAA;EAEA,mBAAA,EAAA,oBAAA;EACA,uBAAA,EAAA,cAAA;EAEA,iBAAA,EAAA,qDAAA;AATF;;AAYA,qDAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EAEA,+BAAA;EACA,4BAAA;AAVF;;AAaA,2DAAA;AACA;EACE,kBAAA;AAVF;;AAaA,sBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AAVF;;AAaA,wDAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAVF;;AAaA,2DAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAVF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAVF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAVF;;AAaA;;EAEE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;AAVF;;AAaA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;AAVF;;AAaA,wEAAA;AACA;EACE,OAAA;EACA,aAAA;EACA,WAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAVF;;AAaA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAVF;;AAaA,wDAAA;AACA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,2DAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;AAVF;;AAaA;EACE,sBAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;AAVF;AAYE;EACE,uBAAA;EACA,uBAAA;AAVJ;;AAcA;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAXF;;AAcA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAXF;AAaE;EACE,iBAAA;AAXJ;;AAeA;EACE,yBAAA;AAZF;;AAeA,oEAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,aAAA;AAZF;;AAeA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAZF;;AAeA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAZF;;AAeA;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAZF;;AAeA;EACE,WAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;AAZF;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;AAZF;AAcE;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAZJ;;AAgBA;EACE,6BAAA;EACA,8BAAA;EACA,cAAA;AAbF;;AAgBA,8DAAA;AAEA,wBAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAdF;EAiBA;IACE,WAAA;IACA,YAAA;EAfF;EAkBA;IACE,eAAA;EAhBF;EAmBA;IACE,iCAAA;EAjBF;AACF;AAmBA,2BAAA;AAEA,yBAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAlBF;EAqBA;IACE,WAAA;IACA,YAAA;EAnBF;EAsBA;IACE,eAAA;EApBF;EAuBA;IACE,iCAAA;EArBF;EAwBA;IACE,wBAAA;IACA,mBAAA;IACA,uBAAA;EAtBF;AACF;AAwBA,4BAAA;AAEA,yBAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAvBF;EA0BA;IACE,WAAA;IACA,YAAA;EAxBF;EA2BA;IACE,eAAA;EAzBF;EA4BA;IACE,kCAAA;EA1BF;EA6BA;IACE,4BAAA;EA3BF;EA+BA;IACE,wBAAA;EA7BF;AACF;AA+BA,4BAAA","sourcesContent":[".no-padding {\r\n  padding: 0 !important;\r\n}\r\n\r\n.left-col {\r\n  padding-left: 0 !important;\r\n  padding-right: 5px !important;\r\n}\r\n\r\n.right-col {\r\n  padding-right: 0 !important;\r\n  padding-left: 5px !important;\r\n}\r\n\r\n.info-text-medium {\r\n  font-size: var(--font-size-medium) !important;\r\n}\r\n\r\n.info-text-small {\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n/* ===================== FAB BUTTONS ===================== */\r\n/* Keep your structure, but reduce repetition and ensure predictable sizing */\r\n.avatar-fab,\r\n.fab {\r\n  margin: 5px 0;\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.text-warning {\r\n  color: var(--ion-color-warning);\r\n}\r\n\r\n.text-danger {\r\n  color: var(--ion-color-danger);\r\n}\r\n\r\n/* ===================== MAIN CARD ===================== */\r\n.pilot-info-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n  overflow: hidden; // prevents children overflow from rounding edges\r\n}\r\n\r\n.pilot-info-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  gap: 5px;\r\n  min-height: 0; // important for internal scrollables\r\n}\r\n\r\n/* ===================== HEADER ROW ===================== */\r\n/* Row can keep its structure, but allow it to grow naturally */\r\n.pilot-info-row {\r\n  width: 100%;\r\n  height: 20%;\r\n  min-height: 0;\r\n  max-height: 160px;\r\n  align-items: center;\r\n}\r\n\r\n/* Ion-avatar host: do NOT use 100%/100% here on big screens */\r\n.pilot-avatar {\r\n  /* stable responsive size */\r\n  width: clamp(64px, 8vw, 120px);\r\n  height: clamp(64px, 8vw, 120px);\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  /* ionic default sometimes clips inner content */\r\n  overflow: visible !important;\r\n}\r\n\r\n/* Real DOM wrapper: anchors the FAB reliably */\r\n.avatar-wrapper {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  overflow: visible;\r\n}\r\n\r\n/* mask clips to circle AND centers content */\r\n.avatar-mask {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  background: white; /* keep if you want */\r\n}\r\n\r\n/* IMPORTANT: don't stretch logos to 100% both ways */\r\n.avatar-mask img.avatar-image {\r\n  width: auto;\r\n  height: auto;\r\n\r\n  max-width: 100%;\r\n  max-height: 100%;\r\n\r\n  object-fit: contain;\r\n  object-position: center;\r\n\r\n  display: block;\r\n}\r\n\r\n/* Image/icon fill wrapper */\r\n.avatar-image {\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  display: block;\r\n\r\n  object-fit: contain;     /* show full image */\r\n  object-position: center; /* center it */\r\n\r\n  background: white;       /* optional: prevents transparent logos looking odd */\r\n}\r\n\r\n/* FAB stays inside the avatar even on huge screens */\r\n.avatar-fab {\r\n  position: absolute;\r\n  bottom: 2px;\r\n  left: 4px;\r\n  z-index: 20;\r\n\r\n  /* keep clickable and visible */\r\n  overflow: visible !important;\r\n}\r\n\r\n/* ion-icon placeholder should also behave like the image */\r\n.pilot-avatar ion-icon.avatar-image {\r\n  border-radius: 50%;\r\n}\r\n\r\n/* Pilot info column */\r\n.pilot-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  min-height: 0;\r\n}\r\n\r\n.actions-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n/* ===================== ADDRESS ===================== */\r\n.address-info-row {\r\n  width: 100%;\r\n  height: 7.5%;\r\n  min-height: 0;\r\n}\r\n\r\n.address-info-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.address-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0 5px; // FIX: was \"0 5\"\r\n}\r\n\r\n.address-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  min-width: 0;\r\n}\r\n\r\n/* ===================== OTHER INFO ===================== */\r\n.other-info-row {\r\n  width: 100%;\r\n  height: 7.5%;\r\n  min-height: 0;\r\n}\r\n\r\n.other-info-col-left {\r\n  padding: 0 5px 0 0;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.other-info-col-right {\r\n  padding: 0 0 0 5px;\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n.id-info-card,\r\n.mocca-info-card {\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: row;\r\n  padding: 5px;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.id-icon-col,\r\n.mocca-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.id-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  min-width: 0;\r\n}\r\n\r\n.mocca-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start; // \"left\" is not valid, use flex-start\r\n  min-width: 0;\r\n}\r\n\r\n/* ===================== CERTIFICATES + VEHICLES ===================== */\r\n.certificates-row {\r\n  flex: 1;\r\n  min-height: 0;\r\n  width: 100%;\r\n}\r\n\r\n.certificates-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  min-height: 0;\r\n}\r\n\r\n.certificates-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.certificates-card-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: 12%;\r\n  padding: 5px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.certificates-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.certificates-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  min-width: 0;\r\n}\r\n\r\n/* Grid list that scrolls correctly inside flex layout */\r\n.certificates-card-content {\r\n  width: 100%;\r\n  flex: 1;\r\n  min-height: 0; // important for overflow scroll\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(150px, 30%));\r\n  grid-auto-rows: min-content;\r\n  justify-content: center;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n  gap: 10px;\r\n}\r\n\r\n.certificate-card {\r\n  width: 100% !important;\r\n  margin: 0;\r\n  height: auto;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.certificate-row {\r\n  min-height: 0;\r\n  height: auto !important;\r\n  display: flex;\r\n  width: 100%;\r\n\r\n  ion-col {\r\n    height: auto !important;\r\n    padding: 5px !important;\r\n  }\r\n}\r\n\r\n.certificate-image {\r\n  max-height: 25px;\r\n  width: 100%;\r\n  object-fit: contain;\r\n  margin: 0 auto;\r\n  display: block;\r\n}\r\n\r\n.certificate-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.certificate-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  min-width: 0;\r\n}\r\n\r\n.certificate-arrow {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.certificate-expand-icon {\r\n  cursor: pointer;\r\n}\r\n\r\n.collapsible-content {\r\n  overflow: hidden;\r\n  transition: max-height 0.3s ease;\r\n  max-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &.expanded {\r\n    max-height: 200px; // Adjust as needed\r\n  }\r\n}\r\n\r\n.always-visible {\r\n  display: block !important;\r\n}\r\n\r\n/* ===================== ASSOCIATED VEHICLES ===================== */\r\n.associated-vehicles-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  min-height: 0;\r\n}\r\n\r\n.associated-vehicles-card {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n}\r\n\r\n.associated-vehicles-card-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  height: 12%;\r\n  padding: 5px;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.associated-vehicles-icon-col {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 0;\r\n}\r\n\r\n.associated-vehicles-info-col {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  min-width: 0;\r\n}\r\n\r\n.associated-vehicles-card-content {\r\n  width: 100%;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n  gap: 10px;\r\n  justify-content: center;\r\n}\r\n\r\n.session-item-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n  padding: 5px 10px;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.session-info-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin-left: 1vw;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n\r\n  ion-label {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n}\r\n\r\n.droneIcon {\r\n  width: var(--icon-size-large);\r\n  height: var(--icon-size-large);\r\n  flex: 0 0 auto;\r\n}\r\n\r\n/* ===================== MEDIA QUERIES ===================== */\r\n\r\n/*#region Small Screens*/\r\n@media (max-width: 599px) {\r\n  .fab {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n\r\n  .avatar-fab {\r\n    width: 15px;\r\n    height: 15px;\r\n  }\r\n\r\n  .card-icon {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .info-text {\r\n    font-size: var(--font-size-small);\r\n  }\r\n}\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n@media (min-width: 600px) and (max-width: 1023px) {\r\n  .fab {\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n\r\n  .avatar-fab {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n\r\n  .card-icon {\r\n    font-size: 25px;\r\n  }\r\n\r\n  .info-text {\r\n    font-size: var(--font-size-small);\r\n  }\r\n\r\n  .certificate-arrow {\r\n    display: flex !important;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n}\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n@media (min-width: 1024px) {\r\n  .fab {\r\n    width: 45px;\r\n    height: 45px;\r\n  }\r\n\r\n  .avatar-fab {\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n\r\n  .card-icon {\r\n    font-size: 35px;\r\n  }\r\n\r\n  .info-text {\r\n    font-size: var(--font-size-medium);\r\n  }\r\n\r\n  .collapsible-content {\r\n    max-height: 200px !important; // Always show content\r\n  }\r\n\r\n  // Hide arrows on larger screens\r\n  .certificate-arrow {\r\n    display: none !important;\r\n  }\r\n}\r\n/*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
